export default {
  title: {
    en: 'Accepted ({count})',
  },
  allBets: {
    en: 'All Bets',
  },
  empty: {
    title: {
      en: 'No accepted bets',
    },
    text: {
      en: 'All accepted bets will be listed here',
    },
  },
}
